import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  NamedLink,
} from '../../components';
import css from './TermsOfService.module.css';

const TermsOfService = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  // prettier-ignore
  return (
    <div className={classes}>
      <div className={css.separator} />

      <h2>PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS SITE</h2>

      <h3>What's in these terms?</h3>

      <p>
        These terms tell you the rules for using our website <a href="www.semoto.io" target="_blank">www.semoto.io</a> (our site).
      </p>
      <p>
        Click on the links below to go straight to more information on each area:
      </p>

      <ol>
        <li>
          <a href="#whoWeAre">Who we are and how to contact us.</a>
        </li>
        <li>
          <a href="#byUsingOurSite">By using our site you accept these terms.</a>
        </li>
        <li>
          <a href="#thereAreOtherTerms">There are other terms that may apply to you.</a>
        </li>
        <li>
          <a href="#weMayMakeTerms">We may make changes to these terms.</a>
        </li>
        <li>
          <a href="#weMayMakeSite">We may make changes to our site.</a>
        </li>
        <li>
          <a href="#weMaySuspendSite">We may suspend or withdraw our site.</a>
        </li>
        <li>
          <a href="#weMayTransfer">We may transfer this agreement to someone else.</a>
        </li>
        <li>
          <a href="#onlyForPermittedUsers">Our site is only for permitted users.</a>
        </li>
        <li>
          <a href="#keepAccountDetailsSafe">You must keep your account details safe.</a>
        </li>
        <li>
          <a href="#howUseMaterial">How you may use material on our site.</a>
        </li>
        <li>
          <a href="#noTextorDataMining">No text or data mining, or web scraping.</a>
        </li>
        <li>
          <a href="#doNotRely">Do not rely on information on our site.</a>
        </li>
        <li>
          <a href="#weAreNotResponsible">We are not responsible for websites we link to.</a>
        </li>
        <li>
          <a href="#userGeneratedContent">User-generated content is not approved by us.</a>
        </li>
        <li>
          <a href="#howToComplain">How to complain about or report content.</a>
        </li>
        <li>
          <a href="#ourResponsibility">Our responsibility for loss or damage suffered by you.</a>
        </li>
        <li>
          <a href="#howWeMayUseInfo">How we may use your personal information.</a>
        </li>
        <li>
          <a href="#uploadingContentonSite">Uploading content to our site.</a>
        </li>
        <li>
          <a href="#rightsYouAreGiving">Rights you are giving us to use material you upload.</a>
        </li>
        <li>
          <a href="#weAreNotResponsibleForViruses">We are not responsible for viruses and you must not introduce them.</a>
        </li>
        <li>
          <a href="#rulesAboutLinkingToSite">Rules about linking to our site.</a>
        </li>
        <li>
          <a href="#whichCountrysLaw">Which country's laws apply to any disputes?</a>
        </li>
        <li>
          <a href="#ourTrademarks">Our trademarks.</a>
        </li>
        <li>
          <a href="#weUseAutomatedProcessing">We use automated processing.</a>
        </li>
        <li>
          <a href="#weRestrictCertainActivities">We restrict certain activities.</a>
        </li>
      </ol>

      <h3 id="whoWeAre">Who we are and how to contact us</h3>

      <p>
        <a href="www.semoto.io" target="_blank">www.semoto.io</a> is a site operated by Semoto Ltd ("We" or “Semoto”). We are
        registered in England and Wales under company number 12629418 and have our
        registered office at 68 Park Road East, London, England, W3 8TY. Our main
        trading address is 20-22 Wenlock Road, London, England, N1 7GU.
      </p>
      <p>
        We are a limited company.
      </p>
      <p>
        To contact us, please email <a href="mailto:support@semoto.io">support@semoto.io</a> or telephone our customer
        service line on <a href="tel:+4402031006834">(+44) 02031 006 834</a>.
      </p>

      <h3 id="byUsingOurSite" >By using our site you accept these terms</h3>

      <p>
        By using our site, you confirm that you accept these terms of use and that you agree to comply with them.
        If you do not agree to these terms, you must not use our site.
      </p>
      <p>
        We recommend that you print a copy of these terms for future reference.
      </p>

      <h3 id="thereAreOtherTerms" >There are other terms that may apply to you</h3>
      <p>
        These terms of use refer to the following additional terms, which also apply to your use of our site:
      </p>

      <ul>
        <li>
          Our <NamedLink name="PrivacyPolicyPage">Privacy Policy</NamedLink>, which sets out how we look after your personal data when you visit our website (regardless of where you visit it from) and tells you about your privacy rights and how the law protects you.
        </li>
        <li>
          Our Acceptable Use Policy, which sets out the permitted uses and prohibited uses of our site. When using our site, you must comply with this Acceptable Use Policy.
        </li>
        <li>
          Our Cookie Policy [COOKIE POLICY LINK], which sets out information about the cookies on our site.
        </li>
        <li>
          If you purchase goods or services from our site, our Terms, and conditions of supply will apply to the sales.
        </li>
      </ul>

      <h3 id="weMayMakeTerms" >We may make changes to these terms</h3>
      <p>
        We amend these terms from time to time. Every time you wish to use our site,
        please check these terms to ensure you understand the terms that apply at that time.
        These terms were most recently updated on 10 April 2023.
      </p>

      <h3 id="weMayMakeSite" >We may make changes to our site</h3>
      <p>
        We may update and change our site from time to time to reflect changes to our products,
        our users' needs and our business priorities. We will try to give you reasonable notice of any major changes.
      </p>

      <h3 id="weMaySuspendSite" >We may suspend or withdraw our site</h3>

      <p>
        To access certain Semoto features, services and/or products, you may be required to pay a fee or fees.
        <br />
        We do not guarantee that our site, or any content on it, will always be available or be uninterrupted.
        We may suspend or withdraw or restrict the availability of all or any part of our site for business
        and operational reasons. We will try to give you reasonable notice of any suspension or withdrawal.
      </p>
      <p>
        You are also responsible for ensuring that all persons who access our site through your internet
        connection are aware of these terms of use and other applicable terms and conditions, and that
        they comply with them.
      </p>


      <h3 id="weMayTransfer" >We may transfer this agreement to someone else</h3>
      <p>
        We may transfer our rights and obligations under these terms to another organisation.
        We will always tell you in writing if this happens and we will ensure that the transfer
        will not affect your rights under the contract.
      </p>

      <h3 id="onlyForPermittedUsers" >Our site is only for permitted users</h3>
      <p>
        This site, its content and any services provided in relation to the same are only targeted at,
        and intended for use by, any person or entity in any jurisdiction or country where such
        distribution or use is not contrary to law or regulation, or which would not otherwise
        subject us to any registration requirement within such jurisdiction or
        country (each, a “Permitted User”). By continuing to access, view or make
        use of this site and any related content and services, you hereby warrant and
        represent to us that you are a Permitted User. If you are not a Permitted User,
        you must immediately discontinue use of this site and any related content and services.
      </p>
      <p>
        The site is intended for users who are at least 18 years old. People under the age
        of 18 are not permitted to use or register for the site.
      </p>

      <h3 id="keepAccountDetailsSafe" >You must keep your account details safe</h3>

      <p>
        If you choose, or you are provided with, a user identification code, password, or any other
        piece of information as part of our security procedures, you must treat such information as
        confidential. You must not disclose it to any third party.
      </p>

      <p>
        We have the right to disable any user identification code or password, whether chosen
        by you or allocated by us, at any time, if in our reasonable opinion you have failed
        to comply with any of the provisions of these terms of use.
      </p>

      <p>
        If you know or suspect that anyone other than you knows your user identification code
        or password, you must promptly notify us at <a href="mailto:support@semoto.io">support@semoto.io</a>.
      </p>


      <h3 id="howUseMaterial" >How you may use material on our site</h3>

      <p>
        We are the owner or the licensee of all intellectual property rights in our site,
        and in the material published on it. Those works are protected by copyright laws and
        treaties around the world. All such rights are reserved.
      </p>
      <p>
        You may print off one copy, and may download extracts, of any page(s) from our site
        for your personal use and you may draw the attention of others within your organisation
        to content posted on our site.
      </p>
      <p>
        You must not modify the paper or digital copies of any materials you have printed off or
        downloaded in any way, and you must not use any illustrations, photographs, video or audio
        sequences or any graphics separately from any accompanying text.
        <br />
        Our status (and that of any identified contributors) as the authors of content on our
        site must always be acknowledged (except where the content is user-generated).
      </p>
      <p>
        You must not use any part of the content on our site for commercial purposes without
        obtaining a licence to do so from us or our licensors.
      </p>

      <p>
        If you print off, copy, download, share or repost any part of our site in breach of
        these terms of use, your right to use our site will cease immediately and you must, at
        our option, return or destroy any copies of the materials you have made.
      </p>

      <h3 id="noTextorDataMining" >No text or data mining or web scraping</h3>

      <p>
        You shall not conduct, facilitate, authorise or permit any text or data mining or web scraping in relation to our site or any services provided via, or in relation to, our site. This includes using (or permitting, authorising or attempting the use of):
      </p>

      <ul>
        <li>
          Any "robot", "bot", "spider", "scraper" or other automated device, program, tool, algorithm, code, process or methodology to access, obtain, copy, monitor or republish any portion of the site or any data, content, information or services accessed via the same.
        </li>
        <li>
          Any automated analytical technique aimed at analysing text and data in digital form to generate information which includes but is not limited to patterns, trends and correlations.
        </li>
      </ul>

      <p>
        The provisions in this clause should be treated as an express reservation of our rights in this regard, including for the purposes of Article 4(3) of Digital Copyright Directive ((EU) 2019/790).
      </p>

      <p>
        This clause shall not apply insofar as (but only to the extent that) we are unable to exclude or limit text or data mining or web scraping activity by contract under the laws which are applicable to us.
      </p>


      <h3 id="doNotRely" >
        Do not rely on information on this site
      </h3>

      <p>
        The content on our site is provided for general information only. It is not intended to amount to advice on which you should rely. You must obtain professional or specialist advice before taking, or refraining from, any action on the basis of the content on our site.
      </p>
      <p>
        Although we make reasonable efforts to update the information on our site, we make no representations, warranties or guarantees, whether express or implied, that the content on our site is accurate, complete, or up to date.
      </p>

      <h3 id="weAreNotResponsible" >We are not responsible for websites we link to</h3>
      <p>
        Where our site contains links to other sites and resources provided by third parties, these links are provided for your information only. Such links should not be interpreted as approval by us of those linked websites or information you may obtain from them.
        <br />
        We have no control over the contents of those sites or resources.
      </p>


      <h3 id="userGeneratedContent" >User-generated content is not approved by us</h3>
      <p>
        This website may include information and materials uploaded by other users of the site, including to social media pages, video-sharing sites, bulletin boards and chat rooms. This information and these materials have not been verified or approved by us. The views expressed by other users on our site do not represent our views or values.
      </p>

      <h3 id="howToComplain" >How to complain about or report content</h3>

      <p>
        If you become aware of any material that could comprise or be connected to child sexual abuse or exploitation or that could comprise terrorist content or be connected to terrorism, please contact us immediately at <a href="mailto:support@semoto.io">support@semoto.io</a>.
        <br />
        If you wish to complain about any other content, please contact us at <a href="mailto:support@semoto.io">support@semoto.io</a>.
      </p>


      <h3 id="ourResponsibility" >Our responsibility for loss or damage suffered by you:</h3>

      <ul>
        <li>
          We do not exclude or limit in any way our liability to you where it would be unlawful
          to do so. This includes liability for death or personal injury caused by our negligence
          or the negligence of our employees, agents, or subcontractors and for fraud or fraudulent
          misrepresentation.
        </li>
        <li>
          Different limitations and exclusions of liability will apply to liability arising as
          a result of the supply of any products to you, which will be set out in our Terms and
          conditions of supply.
        </li>
        <li>
          We exclude all implied conditions, warranties, representations, or other terms
          that may apply to our site or any content on it.
        </li>
        <li>
          We will not be liable to you for any loss or damage, whether in contract,
          tort (including negligence), breach of statutory duty, or otherwise, even if
          foreseeable, arising under or in connection with:
        </li>
        <li>
          use of, or inability to use, our site; or
        </li>
        <li>
          use of or reliance on any content displayed on our site.
        </li>
        <li>
          In particular, we will not be liable for:
        </li>
        <li>
          loss of profits, sales, business, or revenue;
        </li>
        <li>
          business interruption;
        </li>
        <li>
          loss of anticipated savings;
        </li>
        <li>
          loss of business opportunity, goodwill, or reputation; or
        </li>
        <li>
          any indirect or consequential loss or damage.
        </li>
      </ul>

      <h3 id="howWeMayUseInfo" >How we may use your personal information</h3>
      <p>
        We will only use your personal information as set out in our <NamedLink name="PrivacyPolicyPage">Privacy Policy</NamedLink>.
      </p>

      <h3 id="uploadingContentonSite" >Uploading content to our site</h3>

      <p>
        Whenever you make use of a feature that allows you to upload content to our site, or to
        make contact with other users of our site, you must comply with the content standards
        set out in our Acceptable Use Policy.
      </p>
      <p>
        You warrant that any such contribution does comply with those standards, and you will be
        liable to us and indemnify us for any breach of that warranty. This means you will be
        responsible for any loss or damage we suffer as a result of your breach of warranty.
        <br />
        Any content you upload to our site will be considered non-confidential and non-proprietary.
        You retain all of your ownership rights in your content, but you are required to grant
        us [and other users of our site] a limited licence to use, store and copy that content and
        to distribute and make it available to third parties. The rights you license to us are described
        in <u>Rights you are giving us to use material you upload</u>.
      </p>
      <p>
        We also have the right to disclose your identity to any third party who is claiming that any content
        posted or uploaded by you to our site constitutes a violation of their intellectual
        property rights or of their right to privacy.
        <br />
        We have the right to remove any posting you make on our site if, in our opinion, your post
        does not comply with the content standards set out in our Acceptable Use Policy.
      </p>
      <p>
        If you wish to contact us in relation to content you have uploaded to our site and that
        we have taken down, please contact <a href="mailto:support@semoto.io"><u>support@semoto.io</u></a>.
      </p>
      <p>
        You are solely responsible for securing and backing up your content.
      </p>
      <p>
        You must not upload any material that could incite a terrorist offence, solicit any person to
        participate in terrorist activities, provide instruction on any method or technique for committing a
        terrorist offence or threaten to commit a terrorist offence.
      </p>

      <h3 id="rightsYouAreGiving" >Rights you are giving us to use material you upload</h3>
      <p>
        When you upload or post content to our site, you grant us the following rights to use that content:
      </p>

      <ul>
        <li>
          a worldwide, non-exclusive, royalty-free, transferable licence to use, reproduce, distribute,
          prepare derivative works of, display, and perform that user-generated content in connection
          with the service provided by the website and across different media including to promote the
          site or the service forever;
        </li>
        <li>
          a worldwide, non-exclusive, royalty-free, transferable licence for other users, partners,
          or advertisers to use the content in accordance with the functionality of the site forever.
        </li>
      </ul>

      <h3 id="weAreNotResponsibleForViruses" >We are not responsible for viruses and you must not introduce them</h3>

      <p>
        We do not guarantee that our site will be secure or free from bugs or viruses.
      </p>
      <p>
        You are responsible for configuring your information technology, computer programmes and
        platform to access our site. You should use your own virus protection software.
      </p>
      <p>
        You must not misuse our site by knowingly introducing viruses, trojans, worms, logic bombs
        or other material that is malicious or technologically harmful. You must not attempt to gain
        unauthorised access to our site, the server on which our site is stored or any server,
        computer or database connected to our site. You must not attack our site via a denial-of-service
        attack or a distributed denial-of service attack. By breaching this provision, you would
        commit a criminal offence under the Computer Misuse Act 1990. We will report any such
        breach to the relevant law enforcement authorities and we will co-operate with those
        authorities by disclosing your identity to them. In the event of such a breach, your
        right to use our site will cease immediately.
      </p>

      <h3 id="rulesAboutLinkingToSite" >Rules about linking to our site</h3>

      <p>
        You may link to our home page, provided you do so in a way that is fair and legal and does
        not damage our reputation or take advantage of it.
      </p>
      <p>
        You must not establish a link in such a way as to suggest any form of association, approval,
        or endorsement on our part where none exists.
      </p>
      <p>
        You must not establish a link to our site in any website that is not owned by you.
      </p>
      <p>
        Our site must not be framed on any other site, nor may you create a link to any part of our
        site other than the home page.
      </p>
      <p>
        We reserve the right to withdraw linking permission without notice.
      </p>
      <p>
        The website in which you are linking must comply in all respects with the content standards
        set out in our Acceptable Use Policy.
        <br />
        If you wish to link to or make any use of content on our site other than that set out above,
        please contact <a href="mailto:support@semoto.io"><u>support@semoto.io</u></a>.
      </p>

      <h3 id="whichCountrysLaw" >Which country's laws apply to any disputes?</h3>
      <p>
        If you are a consumer, please note that these terms of use, their subject matter,
        and their formation, are governed by English law. You and we both agree that the courts
        of England and Wales will have exclusive jurisdiction except that if you are a resident
        of Northern Ireland you may also bring proceedings in Northern Ireland, and if you are
        resident of Scotland, you may also bring proceedings in Scotland.
      </p>
      <p>
        If you are a business, these terms of use, their subject matter, and their
        formation (and any non-contractual disputes or claims) are governed by English law. We both agree
        to the exclusive jurisdiction of the courts of England and Wales.
      </p>

      <h3 id="ourTrademarks">Our trademarks</h3>
      <p>
        Semoto and Semoto.io are trademarks of Semoto Limited. You are not permitted to use them
        without our approval, unless they are part of material you are using as permitted under
        <u>How you may use material on our site</u>.
      </p>

      <h3 id="weUseAutomatedProcessing">We use automated processing</h3>
      <p>
        We use the information and data that you provide and that we have about users to make
        recommendations for connections, content and features that may be useful to you.
        Keeping your profile accurate and up to date helps us to make these recommendations
        more accurate and relevant. For example, we use data and information about you to
        recommend service providers to you and you to service providers. We may also use
        algorithms to learn about your interests and to help organise content relevant to your
        account, in addition to recommending relevant service providers and user connections.
        These algorithms also filter out or limit distribution of low-quality and unsafe
        content to enhance the value of what you see under your account with us.
      </p>

      <h3 id="weRestrictCertainActivities">We restrict certain activities</h3>
      <p>
        Your information and your activities through our site shall not:
      </p>
      <ul>
        <li>
          be false, inaccurate, or misleading;
        </li>
        <li>
          be fraudulent or involve the sale of counterfeit or stolen items;
        </li>
        <li>
          violate Semoto's Acceptable Use Policy;
        </li>
        <li>
          infringe on any third party's copyright, patent, trademark, trade secret or other property
          rights or rights of publicity or privacy;
        </li>
        <li>
          violate any law, statute, ordinance, contract, or regulation (including, but not limited to,
          those governing financial services, consumer protection, unfair competition, antidiscrimination,
          or false advertising);
        </li>
        <li>
          be defamatory, trade libellous, unlawfully threatening or unlawfully harassing;
        </li>
        <li>
          be obscene or contain child pornography;
        </li>
        <li>
          contain any viruses, Trojan horses, worms, time bombs cancelbots, easter eggs or other
          computer programming routines that may damage, detrimentally interfere with, surreptitiously intercept,
          or expropriate any system, data or other personal information; or
        </li>
        <li>
          create liability for Semoto or cause Semoto to lose (in whole or in part) the services of
          its ISP's or other suppliers. If you use or attempt to use the site for purposes other
          than accessing the community marketplace, selecting service providers and managing your
          account (including, but not limited to, tampering, hacking, modifying or otherwise
          corrupting the security or functionality of the site), your account will be terminated
          and you will be subject to damages and other penalties, including criminal prosecution where available.
        </li>
      </ul>















































































































    </div>
  );
};

TermsOfService.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

TermsOfService.propTypes = {
  rootClassName: string,
  className: string,
};

export default TermsOfService;
